import { Component, OnInit } from '@angular/core';
import { StepSharedService } from '../stepshared.service';
import { PackageDetails } from 'src/app/settings/models/package-details.model';
import { SettingsService } from 'src/app/core/services/http/settings.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { UserSessionService } from 'bna-angular-auth-client';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-onboarding-step-two-component',
  templateUrl: './onboarding-step-two-component.component.html',
  styleUrls: ['./onboarding-step-two-component.component.scss'],
})
export class OnboardingStepTwoComponentComponent implements OnInit {
  isIconVisible: boolean = false;
  packages: PackageDetails;
  isLoadingPackages: boolean;
  public readonly maintenanceAppUrl: string;
  constructor(
    private sharedService: StepSharedService,
    private settingsService: SettingsService,
    private toasterService: TosterService,
    public userSessionService: UserSessionService,
  ) {
    this.maintenanceAppUrl = this.userSessionService.addSessionQueryParams(
      `${environment.maintenanceApp.baseUrl}`
    );
  }

  ngOnInit(): void {
    this.getPackageDetails();
  }

  next() {
    const nextStep = 3;
    this.sharedService.changeStep(nextStep);
  }
  back() {
    const nextStep = 1;
    this.sharedService.changeStep(nextStep);
  }
  toggleIcon() {
    this.isIconVisible = !this.isIconVisible;
  }

  getPackageDetails() {
    this.isLoadingPackages = true;
    this.settingsService.getPackages().subscribe({
      next: (res) => {
        this.packages = res;
        this.packages.pricePerUnit = (
          res.minimumPackageAmount / res.minimumNoOfUnits
        ).toFixed(2);
        this.isLoadingPackages = false;
      },
      error: (error) => {
        this.toasterService.error(error);
        this.isLoadingPackages = false;
      },
    });
  }
}
